import { createSlice } from "@reduxjs/toolkit";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import {
  getAllAppointments,
  deleteAppointment,
} from "../../../api/appointmentAPI";

export const appointmentSlice = createSlice({
  name: "appointment",
  initialState: {
    appointments: [],
    pagination: {},
    page: 0,
    rowsPerPage: 100,
    searchValue: "",
    sort: "asc",
    sortBy: "eventDateTime",
    selectedId: null,
    selectedAppointment: null,
    viewOrderGroupModalOpen: false,
    deleteModalOpen: false,
    successMessage: "",
    errorMessage: "",
  },
  reducers: {
    setSelectedId: (state, action) => {
      state.selectedId = action.payload;
    },
    setSelectedAppointment: (state, action) => {
      state.selectedAppointment = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setPagination: (state, action) => {
      state.pagination = action.payload;
    },
    setSort: (state, action) => {
      state.sort = action.payload;
    },
    setSortBy: (state, action) => {
      state.sortBy = action.payload;
    },
    setSearchValue: (state, action) => {
      state.searchValue = action.payload;
    },
    setAppointments: (state, action) => {
      state.appointments = action.payload;
    },
    showViewOrderGroupModal: (state, action) => {
      state.viewOrderGroupModalOpen = action.payload;
    },
    showDeleteModal: (state, action) => {
      state.deleteModalOpen = action.payload;
    },
    setSuccessMessage: (state, action) => {
      state.successMessage = action.payload;
    },
    setErrorMessage: (state, action) => {
      state.errorMessage = action.payload;
    },
  },
});

export const {
  setSearchValue,
  setSelectedId,
  setSelectedAppointment,
  setPage,
  setRowsPerPage,
  setPagination,
  setSort,
  setSortBy,
  setAppointments,
  showViewOrderGroupModal,
  showDeleteModal,
  setSuccessMessage,
  setErrorMessage,
} = appointmentSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.vendor.value)`
export const selectState = (state) => state.appointment;

export const handleGetAppointments = () => async (dispatch, getState) => {
  dispatch(showLoading());
  const state = getState();

  try {
    const response = await getAllAppointments(
      state.appointment.page,
      state.appointment.rowsPerPage,
      state.appointment.sort,
      state.appointment.sortBy,
      state.appointment.searchValue
    );
    const { content, ...pagination } = response.data;

    dispatch(setPagination(pagination));
    dispatch(setAppointments(content));
    dispatch(setSelectedId(null));
  } catch (error) {
    console.log(error.message);
  } finally {
    dispatch(hideLoading());
  }
};

export const handleDeleteAppointment = () => async (dispatch, getState) => {
  dispatch(showLoading());
  const state = getState();

  try {
    await deleteAppointment(state.appointment.selectedId);
    dispatch(showDeleteModal(false));
    dispatch(setSuccessMessage("Successfully delete appointment!"));
    dispatch(handleGetAppointments);
    dispatch(setSelectedId(null));
  } catch (error) {
    dispatch(setErrorMessage(error.response?.data ?? error.message));
  } finally {
    dispatch(hideLoading());
  }
};

export default appointmentSlice.reducer;
